import { OnInit, EventEmitter, TemplateRef, OnDestroy, ElementRef, Renderer2 } from '@angular/core';
import { ReportObject, PageContent } from '../objects/WorkObject';
import { WorkspaceService } from '../services/workspace.service';
import { ConversationService } from '../services/conversation.service';
import { ConfirmationService } from '../services/confirmation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ContextMenuComponent, ContextMenuService } from 'node_modules/ngx-contextmenu';
import { ThemeSettingService } from '../services/theme-setting.service';
import { LoadingSummaryService } from '../services/loading-summary.service';
import { BsModalService } from 'ngx-bootstrap';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { DetailService } from '../services/detail.service';
import { SummaryService } from '../services/summary.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { MainLoadingService } from '../services/main-loading.service';
import { MdePopoverTrigger } from '@material-extended/mde';
import { EnvService } from '../env.service';
var ReportcardComponent = /** @class */ (function () {
    function ReportcardComponent(contextMenuService, workspaceService, conversationService, confirmationService, route, modalService, router, themeSettingService, loadingSummaryService, detailService, elRef, renderer, summaryService, workflowReturn, mainLoadingService, env) {
        var _this = this;
        this.contextMenuService = contextMenuService;
        this.workspaceService = workspaceService;
        this.conversationService = conversationService;
        this.confirmationService = confirmationService;
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this.themeSettingService = themeSettingService;
        this.loadingSummaryService = loadingSummaryService;
        this.detailService = detailService;
        this.elRef = elRef;
        this.renderer = renderer;
        this.summaryService = summaryService;
        this.workflowReturn = workflowReturn;
        this.mainLoadingService = mainLoadingService;
        this.env = env;
        this.hideOutline = false;
        this.variables = {};
        this.trueVar = true;
        this.refreshView = false;
        this.triggerChartLoading = false;
        this.sampleValue = '<ol><li>A further review of trend anomalies across categories may be initiated.<br><span class="btn-commentary" data-action="TNDetails"><i class="fa fa-users"></i> Activate Review Team</span><span class="btn-commentary" data-action="RFQDetails"><i class="fa fa-address-card"></i> Contact VPC</span></li><br><li>Deep dive into the Packaging Material category to understand optimisation opportunities.<br><span class="btn-commentary" data-action="RFQ"><i class="fa fa-users"></i> Activate Review Team</span><span class="btn-commentary" data-action=""><i class="fa fa-address-card"></i> Contact VPC</span></li></ol>';
        this.dialog = false;
        this.variableChanged = new EventEmitter();
        this.getRelatedEpic = new EventEmitter();
        this.hidePanel = new EventEmitter();
        this.sub = themeSettingService.themeSettingChanged$.subscribe(function (value) {
            if (_this.reportObject.BackgroundColor != "#FFF") {
                _this.reportObject.BackgroundColor = value.primaryColour;
            }
        });
    }
    Object.defineProperty(ReportcardComponent.prototype, "setReport", {
        set: function (report) {
            var _this = this;
            this.reportObject = report;
            this.sortByMetadataType();
            if (this.reportObject.Metadata.length > 0) {
                var types = this.reportObject.Metadata.map(function (item) { return item.MetadataTypeDescription; }).filter(function (value, index, self) { return self.indexOf(value) === index; });
                this.metadataObject = [];
                types.forEach(function (element) {
                    var list = _this.reportObject.Metadata.filter(function (x) { return x.MetadataTypeDescription == element; });
                    list = _this.sortByMetadataName(list);
                    _this.metadataObject.push({ Type: element, Metadata: list });
                });
            }
            this.MapBindingIds();
            if (this.reportObject.ContentInitializeParameter.startsWith("@")) {
                var urlParam = this.reportObject.ContentInitializeParameter.split(":")[0];
                var initParamName = this.reportObject.ContentInitializeParameter.split(":")[1];
                if (urlParam && this.route.snapshot.paramMap.get(urlParam)) {
                    this.SetVariableValue(initParamName, this.route.snapshot.paramMap.get(urlParam));
                }
            }
            else {
                this.paramList = new Array();
                this.contentParamList = new Array();
                this.route.snapshot.paramMap.keys.forEach(function (key) {
                    if (key.startsWith("@")) {
                        _this.paramList.push({ key: key, value: _this.route.snapshot.paramMap.get(key) });
                    }
                });
                if (this.reportObject.TemplateType == "Charts") {
                    this.triggerChartLoading = true;
                }
                this.workspaceService.getEPICContent(this.reportObject.GroupId, this.reportObject.EPICId, this.paramList).subscribe(function (result) {
                    if (result) {
                        _this.SetVariableValue(_this.reportObject.ContentInitializeParameter, result);
                    }
                    else {
                        if (_this.reportObject.TemplateType == "Charts") {
                            _this.triggerChartLoading = false;
                        }
                    }
                }, function (error) {
                    if (_this.reportObject.TemplateType == "Charts") {
                        _this.triggerChartLoading = false;
                    }
                });
            }
            this.constructRatio(this.reportObject);
            this.replaceURLParam();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportcardComponent.prototype, "updateVariable", {
        set: function (groupVariables) {
            var tempVar = Object.assign({}, groupVariables);
            this.variables = tempVar;
        },
        enumerable: true,
        configurable: true
    });
    ReportcardComponent.prototype.ngOnInit = function () {
    };
    ReportcardComponent.prototype.ngOnDestroy = function () {
        if (this.sub)
            this.sub.unsubscribe();
    };
    ReportcardComponent.prototype.replaceURLParam = function () {
        var _this = this;
        if (this.reportObject.Content.toUpperCase().indexOf("@URLPARAM") > -1) {
            var urlParam = this.reportObject.Content.substr(this.reportObject.Content.indexOf("@")).replace("}", "").replace(" ", "").replace('"', '');
            this.paramList.forEach(function (element) {
                if (element.key.toUpperCase().trim() === urlParam.toUpperCase().trim()) {
                    _this.reportObject.Content = _this.reportObject.Content.replace(new RegExp('\n', 'g'), "");
                    var tempObj = JSON.parse(_this.reportObject.Content);
                    _this.groupTypeInView = tempObj["GroupType"].replace(urlParam.trim(), element.value);
                }
            });
        }
        if (this.reportObject.Content.indexOf("InputFilterValue") > -1) {
            var tempObj = JSON.parse(this.reportObject.Content.replace(new RegExp('\n', 'g'), ""));
            this.inputComboFilter = tempObj["InputFilterValue"];
        }
        if (this.reportObject.TemplateType.toUpperCase() == "POPUPBUTTON") {
            var tempObj = JSON.parse(this.reportObject.Content.replace(new RegExp('\n', 'g'), ""));
            // if (this.reportObject.Content.indexOf("Action") > -1){
            this.broadcastAction = tempObj["Action"];
            // }
            this.broadcastDocId = this.route.snapshot.paramMap.get(tempObj["DocId"]);
            this.broadcastDocType = tempObj["DocType"];
            this.broadcastType = tempObj["Type"];
            if (tempObj["Color"]) {
                this.broadcastColor = tempObj["Color"];
            }
            else {
                this.broadcastColor = "#af2bbf";
            }
        }
        else if (this.reportObject.TemplateType.toUpperCase() == "KHAMISSEARCH") {
            if (this.reportObject.Content) {
                var tempObj = JSON.parse(this.reportObject.Content.replace(new RegExp('\n', 'g'), ""));
                this.khamisSearchType = tempObj["Type"];
            }
        }
    };
    ReportcardComponent.prototype.popover = function (trigger) {
        var _this = this;
        if (this.btnInstance) {
            this.btnInstance();
        }
        setTimeout(function () {
            if (_this.elRef.nativeElement.querySelector('.btn-commentary')) {
                _this.btnInstance = _this.renderer.listen('document', 'click', function (evt) {
                    var element = evt.target;
                    if (element) {
                        if (element.className == "btn-commentary") {
                            var dataAction = element.getAttribute('data-action');
                            var summaryItemId = element.getAttribute('data-summaryitemid');
                            var sectionId = element.getAttribute('data-sectionid');
                            var groupId = element.getAttribute('data-groupid');
                            var compareIds = element.getAttribute('data-compareids');
                            _this.commentAction(dataAction, summaryItemId, sectionId, groupId, compareIds);
                        }
                    }
                });
            }
        });
    };
    ReportcardComponent.prototype.popoverClose = function () {
        if (this.btnInstance) {
            this.btnInstance();
        }
    };
    ReportcardComponent.prototype.commentAction = function (dataAction, summaryItemId, sectionId, groupId, compareIds) {
        var _this = this;
        //find TN/RFQ summary
        if (dataAction == "RFQDetails") {
            // data-summaryitemid
            this.mainLoadingService.setLoading(true);
            this.summaryService.createSummary("RFQ", "DefaultView").subscribe(function (summaryId) {
                if (summaryId) {
                    _this.summaryService.selectItem(summaryId, summaryItemId).subscribe(function (wfs) {
                        if (wfs) {
                            _this.mdePopover.closePopover();
                            _this.popoverClose();
                            var wfAction = JSON.parse(wfs);
                            _this.workflowReturn.handleWorkflowReturn(wfAction, true);
                            _this.mainLoadingService.setLoading(false);
                        }
                    }, function (error) {
                        _this.mainLoadingService.setLoading(false);
                    });
                }
            }, function (error) {
                _this.mainLoadingService.setLoading(false);
            });
        }
        else if (dataAction == "RFQ") {
            // data-summaryitemid
            this.mainLoadingService.setLoading(true);
            var action = "RFQ_COMPAREQUOTE";
            this.summaryService.createSummary("RFQ", "DefaultView").subscribe(function (summaryId) {
                if (summaryId) {
                    _this.summaryService.selectItem(summaryId, summaryItemId).subscribe(function (wfs) {
                        if (wfs) {
                            var wf = JSON.parse(wfs);
                            if (wf.Arguments[0] && wf.ReturnType == 3) {
                                var detailId = wf.Arguments[0];
                                _this.detailService.detailAction(detailId, action).subscribe(function (actionResult) {
                                    _this.mdePopover.closePopover();
                                    _this.popoverClose();
                                    var wfAction = JSON.parse(actionResult);
                                    _this.workflowReturn.handleWorkflowReturn(wfAction);
                                    _this.mainLoadingService.setLoading(false);
                                }, function (error) {
                                    _this.mainLoadingService.setLoading(false);
                                });
                            }
                        }
                    }, function (error) {
                        _this.mainLoadingService.setLoading(false);
                    });
                }
            }, function (error) {
                _this.mainLoadingService.setLoading(false);
            });
        }
        else if (dataAction == "TNDetails") {
            // data-summaryitemid
            this.mainLoadingService.setLoading(true);
            this.summaryService.createSummary("TN", "BuyerView").subscribe(function (summaryId) {
                if (summaryId) {
                    _this.summaryService.selectItem(summaryId, summaryItemId).subscribe(function (wfs) {
                        if (wfs) {
                            _this.mdePopover.closePopover();
                            _this.popoverClose();
                            var wfAction = JSON.parse(wfs);
                            _this.workflowReturn.handleWorkflowReturn(wfAction, true);
                            _this.mainLoadingService.setLoading(false);
                        }
                    }, function (error) {
                        _this.mainLoadingService.setLoading(false);
                    });
                }
            }, function (error) {
                _this.mainLoadingService.setLoading(false);
            });
        }
        else if (dataAction == "TN") {
            // data-summaryitemid
            // data-sectionId
            // data-groupId
            // data-compareIds
            this.mainLoadingService.setLoading(true);
            var action = "TNDB_COMPARE";
            this.summaryService.createSummary("TN", "BuyerView").subscribe(function (summaryId) {
                if (summaryId) {
                    _this.summaryService.selectItem(summaryId, summaryItemId).subscribe(function (wfs) {
                        if (wfs) {
                            var wf = JSON.parse(wfs);
                            if (wf.Arguments[0] && wf.ReturnType == 3) {
                                var detailId = wf.Arguments[0];
                                _this.detailService.changeSection(detailId, sectionId).subscribe(function (wfss) {
                                    if (wfss == "1") {
                                        _this.summaryService.getNewSummaryFromDetail(detailId, groupId, false).subscribe(function (summaryGroupId) {
                                            if (summaryGroupId) {
                                                var listOf = []; // list of selectedIds
                                                if (compareIds) {
                                                    compareIds.split(",").forEach(function (id) {
                                                        listOf.push([{ name: "DocumentInstanceId", value: id.trim() }]);
                                                    });
                                                }
                                                // listOf.push([{name: "DocumentInstanceId", value: "87651b6a-0bcb-4f4d-b9c7-f7946344707d"}]);
                                                // listOf.push([{name: "DocumentInstanceId", value: "5b415fb4-00c1-4c48-abb4-280be2ee6a98"}]);
                                                // listOf.push([{name: "DocumentInstanceId", value: "6eaa716a-98dd-40e9-abcc-19a2c0059abe"}]);
                                                // var parentList = [];
                                                // parentList.push(listOf);
                                                _this.summaryService.summaryAction(summaryGroupId, listOf, action).subscribe(function (actionResult) {
                                                    _this.mdePopover.closePopover();
                                                    _this.popoverClose();
                                                    var wfAction = JSON.parse(actionResult);
                                                    _this.workflowReturn.handleWorkflowReturn(wfAction);
                                                    _this.mainLoadingService.setLoading(false);
                                                }, function (error) {
                                                    _this.mainLoadingService.setLoading(false);
                                                });
                                            }
                                        }, function (error) {
                                            _this.mainLoadingService.setLoading(false);
                                        });
                                    }
                                }, function (error) {
                                    _this.mainLoadingService.setLoading(false);
                                });
                            }
                        }
                    }, function (error) {
                        _this.mainLoadingService.setLoading(false);
                    });
                }
            }, function (error) {
                _this.mainLoadingService.setLoading(false);
            });
        }
    };
    ReportcardComponent.prototype.sortByMetadataType = function () {
        this.reportObject.Metadata.sort(function (a, b) {
            if (a.MetadataTypeSequence > b.MetadataTypeSequence) {
                return 1;
            }
            else if (a.MetadataTypeSequence < b.MetadataTypeSequence) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    ReportcardComponent.prototype.sortByMetadataName = function (list) {
        return list.sort(function (a, b) {
            if (a.MetadataNameSequence > b.MetadataNameSequence) {
                return 1;
            }
            else if (a.MetadataNameSequence < b.MetadataNameSequence) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    ReportcardComponent.prototype.getRelatedEpics = function (reportGroup) {
        this.getRelatedEpic.emit(reportGroup);
    };
    ReportcardComponent.prototype.MapBindingIds = function () {
        if (this.reportObject.ContentInput) {
            var input = JSON.parse(this.reportObject.ContentInput);
            if (input) {
                switch (this.reportObject.TemplateType.toUpperCase()) {
                    case "DOCUMENTSUMMARY":
                        this.summaryComponentId = input["componentId"];
                        this.summarySearchKeyword = input["searchKeyword"];
                        this.summaryInputChange = input["filterInput"];
                        break;
                    case "DOCUMENTSUBSUMMARY":
                        this.summaryComponentId = input["componentId"];
                        this.summarySearchKeyword = input["searchKeyword"];
                        break;
                    case "DOCUMENTDETAIL":
                        this.detailComponentId = input["setComponentId"];
                        break;
                    case "SEARCHBAR":
                        this.searchPlaceholder = input["placeholder"];
                        this.searchKeyword = input["searchKeyword"];
                        break;
                    case "SEARCHRESULT":
                        this.searchResultChanged = input["searchResultChanged"];
                        this.searchResultId = input["searchResultId"];
                        break;
                    case "MENU":
                        this.menuComponentId = input["componentId"];
                        break;
                    case "INPUTBAR":
                        this.inputComponentId = input["componentId"];
                        break;
                    case "CHARTS":
                        this.chartComponentId = input["componentId"];
                        break;
                    case "OUTLINE":
                        this.outlineComponentId = input["componentId"];
                        break;
                    case "INPUTCOMBO":
                        this.filterComboId = input["componentId"];
                        break;
                    case "VIEWLIST":
                        this.viewListId = input["componentId"];
                        break;
                    case "KEYINDICATOR":
                        this.keyIndicatorComponentId = input["componentId"];
                        break;
                    case "WEBCONTENT":
                        this.webContentComponentId = input["componentId"];
                        break;
                    case "VERTICALPROGRESS":
                        this.progressChanged = input["progressChanged"];
                        break;
                    case "POPUPBUTTON":
                        this.popupButtonId = input["componentId"];
                        break;
                }
            }
            var output = JSON.parse(this.reportObject.ContentOutput);
            if (output) {
                switch (this.reportObject.TemplateType.toUpperCase()) {
                    case "DOCUMENTSUMMARY":
                        this.summarySelectedId = output["selectedId"];
                        this.summaryNameChange = output["nameChange"];
                        this.searchKeywordChanged = output["keywordChanged"];
                        break;
                    case "DOCUMENTSUBSUMMARY":
                        this.subSummarySelectedId = output["selectedId"];
                        this.summaryNameChange = output["nameChange"];
                        break;
                    case "DOCUMENTDETAIL":
                        this.subSummarySelectId = output["subSummarySelectId"];
                        this.propertyValueChanged = output["propertyValueChanged"];
                        this.emitValueChanged = output["emitValue"];
                        break;
                    case "VIEWLIST":
                        this.viewChangedId = output["viewChangedId"];
                        break;
                    case "SEARCHBAR":
                        this.searchKeywordChanged = output["keywordChanged"];
                        break;
                    case "KHAMISSEARCH":
                        this.khamisSearchChanged = output["searchChanged"];
                        this.khamisSearchResultId = output["searchResultId"];
                        break;
                    case "MENU":
                        this.menuComponentIdChanged = output["menuSelectedId"];
                        break;
                    case "INPUTBAR":
                        this.inputValueChanged = output["inputChanged"];
                        break;
                    case "OUTLINE":
                        this.outlineSelectedId = output["selectedDetailId"];
                        break;
                    case "INPUTCOMBO":
                        this.filterComboChanged = output["selectionChanged"];
                        break;
                }
            }
        }
    };
    ReportcardComponent.prototype.SetVariableValue = function (varName, value) {
        if (varName.startsWith('@@')) {
            if (value != 1 && value != 0) {
                var command = varName.split(":")[0].replace("@@", "").toUpperCase();
                var params = varName.substring(command.length + 3).split(":");
                params.push(value);
                switch (command) {
                    case "NAVIGATE":
                        this.router.navigate(params);
                        break;
                    case "POPUP":
                        this.openPopup(value);
                        break;
                }
            }
        }
        else {
            this.variables[varName] = value;
            this.variableChanged.emit(this.variables);
        }
    };
    ReportcardComponent.prototype.GetOutputVariableName = function (paramName) {
        if (this.reportObject != null) {
            var output = JSON.parse(this.reportObject.ContentOutput);
            if (output) {
                return output[paramName];
            }
            else {
                return '';
            }
        }
        else {
            return '';
        }
    };
    ReportcardComponent.prototype.openPopup = function (event, title) {
        var _this = this;
        if (title === void 0) { title = ""; }
        this.clearSummarySelectedItem(event);
        var template;
        // const initialState = {
        //   componentId: event,
        //   title: title
        // };
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-detail',
            initialState: {
                componentId: event,
                title: title
            }
        };
        if (this.modalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
        }
        this.modalService.onHide.subscribe(function (reason) {
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
            }
        });
        this.modalRef = this.modalService.show(DetailPopupComponent, config);
    };
    ReportcardComponent.prototype.clearSummarySelectedItem = function (id) {
        this.detailService.clearSummarySelectedItem(id).subscribe(function (result) {
            //console.log(result); handle
        });
    };
    ReportcardComponent.prototype.constructRatio = function (reportObject) {
        reportObject.FilledSpace = 0;
        if (reportObject.HasHeaderTitle || reportObject.HeaderTitle) {
            reportObject.FilledSpace += this.fontFormat(reportObject.HeaderTitleType);
        }
        else if (reportObject.HasHeaderValue || reportObject.HeaderValue) {
            reportObject.FilledSpace += this.fontFormat(reportObject.HeaderValueType);
        }
        else if ((reportObject.HasSubFooterTitle && reportObject.SubFooterTitle) || (reportObject.HasFooterTitle && reportObject.FooterTitle)) {
            reportObject.FilledSpace += this.fontFormat(reportObject.FooterTitleType);
        }
        else if ((reportObject.HasSubFooterValue && reportObject.SubFooterValue) || (reportObject.HasFooterValue && reportObject.FooterValue)) {
            reportObject.FilledSpace += this.fontFormat(reportObject.FooterValueType);
        }
        else {
            reportObject.FilledSpace += 0.5;
        }
        reportObject.FilledSpace += 0.5;
    };
    ReportcardComponent.prototype.fontFormat = function (format) {
        var value = 0;
        switch (format.toUpperCase()) {
            case "HEADER":
                value = 1.5;
                break;
            case "SUBHEADER":
                value = 1;
                break;
            case "REGULAR":
                value = 1;
                break;
            case "REGULARBOLD":
                value = 1;
                break;
            case "LIGHT":
                value = 0.6875;
                break;
        }
        return value;
    };
    ReportcardComponent.prototype.onContextMenu = function ($event, item) {
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                contextMenu: this.basicMenu,
                event: $event,
                item: item,
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    ReportcardComponent.prototype.togglePanel = function () {
        this.reportObject.IsCollapsed = !this.reportObject.IsCollapsed;
        this.hidePanel.emit(this.reportObject.IsCollapsed);
    };
    ReportcardComponent.prototype.pullPopupUtterance = function (reportObject) {
        var _this = this;
        this.confirmationService.confirm('Add Quick Phrase for ' + reportObject.EPICName, '', ['CANCEL', 'OK'], true, 'Add Quick Phrase...', true)
            .subscribe(function (respond) {
            if (respond.answer == 'OK') {
                // this.isBusy = true;
                _this.conversationService.saveUtteranceForEPIC(respond.inputText, reportObject.EPICId).subscribe(function (result) {
                    // console.log(result);
                });
            }
        });
        // $event.stopPropagation();
    };
    ReportcardComponent.prototype.pullPopupTag = function (reportObject) {
        var _this = this;
        this.confirmationService.confirm('Add Tag for ' + reportObject.EPICName, '', ['CANCEL', 'OK'], true, 'Add Tag...', true)
            .subscribe(function (respond) {
            if (respond.answer === 'OK') {
                // this.isBusy = true;
                _this.conversationService.saveUserTagForEPIC(respond.inputText, reportObject.EPICId).subscribe(function (result) {
                    // console.log(result);
                });
            }
        });
        // $event.stopPropagation();
    };
    ReportcardComponent.prototype.addMetadata = function (reportObject) {
        var _this = this;
        this.mainLoadingService.setLoading(true);
        this.conversationService.saveMetadataForEPIC(reportObject.TemplateType, reportObject.EPICId).subscribe(function (result) {
            _this.mainLoadingService.setLoading(false);
            if (result) {
                _this.workflowReturn.handleWorkflowReturn(JSON.parse(result));
            }
        }, function (error) {
            _this.mainLoadingService.setLoading(false);
        });
    };
    return ReportcardComponent;
}());
export { ReportcardComponent };
var MetadataObject = /** @class */ (function () {
    function MetadataObject() {
    }
    return MetadataObject;
}());
export { MetadataObject };
